import axios from 'axios'


export const asResponse = async (request) => {
  let resp
  try {
    resp = await request
  } catch (e) {
    if (!e.response) {
      throw e
    }
    throw {...e.response, isSilent: e.isSilent}
  }
  return resp
}


export const configureGlobalAxiosSettings = () => {
  axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    // Do something with response error

    if (error && error.response && [401, 403].includes(error.response.status)) {
      const {data = {}} = error.response
      const {details = {}} = data
      const {destination} = details
      if (destination) {
        window.location.href = destination
        return
      }
      else if (window.location.href.indexOf('/auth') === -1) {
        window.location.href = '/c/auth/login'
        return
      }
      return Promise.reject({...error.response, isSilent: true})
    }
    return Promise.reject(error)
  })
}